import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-imprint',
  templateUrl: './imprint.component.html'
})
export class ImprintComponent implements OnInit {

  isLoggedIn: boolean;

  title = [
    '_IMPRINT.TITLE_1',
    '_IMPRINT.TITLE_2'
  ];

  content = '_IMPRINT.CONTENT';

  constructor(private authService: AuthService) {
    this.authService.currentUser.subscribe(currentUser => this.isLoggedIn = !!(currentUser) );
  }

  ngOnInit() {}

}
